
import React from 'react';
import GeniusCardHero from '@/components/genius-card/GeniusCardHero';
import ProblemAgitationSection from '@/components/genius-card/ProblemAgitationSection';
import CostAnalysisSection from '@/components/genius-card/CostAnalysisSection';
import CourseContentSection from '@/components/genius-card/CourseContentSection';
import AILandingPagesGallery from '@/components/genius-card/AILandingPagesGallery';
import ObjectionHandlingSection from '@/components/genius-card/ObjectionHandlingSection';
import UrgencySection from '@/components/genius-card/UrgencySection';
import FinalCTASection from '@/components/genius-card/FinalCTASection';
import CountdownTimer from '@/components/CountdownTimer';

const GeniusCard = () => {
  // Set target date to June 23rd, 2025 at 12:00 AM EST
  const targetDate = new Date('2025-06-23T05:00:00.000Z'); // 12:00 AM EST = 5:00 AM UTC

  return (
    <div className="flex flex-col min-h-screen bg-white">
      {/* Countdown Timer Bar */}
      <div className="bg-[#003a70] py-3 md:py-4 sticky top-0 z-50 shadow-lg">
        <div className="container mx-auto px-4 md:px-8">
          <div className="text-center">
            <h3 className="text-sm md:text-lg font-bold text-white mb-2">Launch Special Offer Closes In:</h3>
            <CountdownTimer 
              targetDate={targetDate} 
              className="bg-transparent text-white"
            />
          </div>
        </div>
      </div>

      <main className="flex-grow">
        <GeniusCardHero />
        <ProblemAgitationSection />
        <CostAnalysisSection />
        <CourseContentSection />
        <AILandingPagesGallery />
        <UrgencySection />
        <ObjectionHandlingSection />
        <FinalCTASection />
      </main>
    </div>
  );
};

export default GeniusCard;
